export function isNullOrUndefined(param) {
    return param === null || param === undefined;
}

// https://davidwalsh.name/query-string-javascript
export function getUrlParam(name) {
    var newName = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + newName + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function transformNameToInitials(firstName, lastName) {
    let firstInitial = '';
    let lastInitial = '';

    if (isNullOrUndefined(firstName) && isNullOrUndefined(lastName)) {
        return '##';
    }

    if (firstName && firstName.length > 0) {
        firstInitial = firstName.slice(0, 1).toUpperCase();
    }

    if (lastName && lastName.length > 0) {
        lastInitial = lastName.slice(0, 1).toUpperCase();
    }

    return firstInitial + lastInitial;
}
